import styled from "styled-components";
import { Typography } from "@/foundation/Typography/V2";

export const StyledApplySection = styled.section`
  padding: 64px 0 80px;
  .apply-section {
    padding: 56px;
    background: ${({ theme }) => theme.colorsV2.blueGray.shade_50};
    border-radius: 16px;
    .title {
      margin: 0 0 16px;
    }
    .description {
      margin: 56px 0;
      @media only screen and (max-width: 767px) {
        margin: 32px 0;
      }
    }
    @media only screen and (max-width: 767px) {
      padding: 24px;
    }
  }
  .container {
    @media only screen and (max-width: 767px) {
      padding: 0 8px;
    }
  }
  @media only screen and (max-width: 767px) {
    padding: 40px 0;
  }
`;

export const AnchorLink = styled.a`
  text-decoration: none;
  color: transparent;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  -webkit-tap-highlight-color: transparent;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    text-decoration: none;
    color: transparent;
  }
`;
export const DynamicText = styled(Typography)`
  * {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
  }
  a:hover {
    color: inherit;
  }
`;
